import script from "./NotifAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./NotifAdmin.vue?vue&type=script&setup=true&lang=js"

import "./NotifAdmin.vue?vue&type=style&index=0&id=637aa2db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-637aa2db"]])

export default __exports__